import React from 'react';

export function Card({ children, className = '' }) {
  return (
    <div
      className={`rounded-2xl border border-red-100 bg-white shadow-sm ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '' }) {
  return (
    <div className={`border-b border-red-50 px-5 py-4 ${className}`}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className = '' }) {
  return (
    <h3 className={`text-lg font-bold text-brand-red ${className}`}>
      {children}
    </h3>
  );
}

export function CardContent({ children, className = '' }) {
  return <div className={`px-5 py-4 ${className}`}>{children}</div>;
}
